import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/global.css'
import * as echarts from 'echarts'
import api from './api'
import { installI18n } from '@/utils/i18n'
import { initCustomTitle, applyCustomTitle } from '@/utils/custom-title'

Vue.use(ElementUI)
installI18n(Vue)
Vue.prototype.$echarts = echarts
Vue.prototype.$api = api

Vue.config.productionTip = false

function syncMobileTableLabels() {
  Vue.nextTick(() => {
    document.querySelectorAll('.el-table').forEach(table => {
      const labels = Array.from(table.querySelectorAll('.el-table__header-wrapper th .cell')).map(cell => cell.textContent.trim())
      table.querySelectorAll('.el-table__body tr').forEach(row => {
        Array.from(row.children).forEach((td, index) => {
          td.setAttribute('data-label', labels[index] || '')
        })
      })
    })
  })
}

Vue.mixin({
  mounted() {
    syncMobileTableLabels()
    applyCustomTitle()
  },
  updated() {
    syncMobileTableLabels()
    applyCustomTitle()
  }
})

initCustomTitle()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
